(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-selling-collection-redesign-updated"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWSD(root) {
    if (root.dataset.wsdInit) return;
    root.dataset.wsdInit = '1';

    var tabs      = Array.prototype.slice.call(root.querySelectorAll('[data-wsd-tab]'));
    var panels    = Array.prototype.slice.call(root.querySelectorAll('[data-wsd-panel]'));
    var tabfill   = root.querySelector('[data-wsd-tabfill]');
    var tablist   = root.querySelector('[data-wsd-tablist]');
    var prevBtn   = root.querySelector('[data-wsd-prev]');
    var nextBtn   = root.querySelector('[data-wsd-next]');
    var viewall   = root.querySelector('[data-wsd-viewall]');
    var viewallTx = root.querySelector('[data-wsd-viewall-text]');
    var count     = tabs.length;
    var active    = 0;

    var viewData = [];
    var jsonEl = root.querySelector('[data-wsd-viewall-json]');
    if (jsonEl) { try { viewData = JSON.parse(jsonEl.textContent); } catch (e) {} }

    function activate(i) {
      i = Math.max(0, Math.min(count - 1, i));
      active = i;

      tabs.forEach(function (t, idx) {
        var on = idx === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p, idx) {
        var on = idx === i;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });

      if (tabfill) {
        var w = 100 / count;
        tabfill.style.width = w + '%';
        tabfill.style.transform = 'translateX(' + (i * 100) + '%)';
      }

      // keep active tab in view (mobile)
      if (tabs[i] && tablist) {
        var t = tabs[i];
        var left = t.offsetLeft - (tablist.clientWidth - t.clientWidth) / 2;
        tablist.scrollTo({ left: left, behavior: 'smooth' });
      }

      // bottom CTA
      if (viewData[i] && viewall) {
        if (viewallTx) viewallTx.textContent = viewData[i].t || '';
        viewall.setAttribute('href', viewData[i].h || '#');
      }

      updateCardProgress();
    }

    tabs.forEach(function (t, idx) {
      t.addEventListener('click', function () { activate(idx); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { activate(active - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { activate(active + 1); });

    // card carousel progress
    function updateCardProgress() {
      var panel = panels[active];
      if (!panel) return;
      var cards = panel.querySelector('[data-wsd-cards]');
      var fill  = panel.querySelector('[data-wsd-cardfill]');
      if (!cards || !fill) return;
      var max = cards.scrollWidth - cards.clientWidth;
      var thumb = Math.max(15, (cards.clientWidth / cards.scrollWidth) * 100);
      fill.style.width = thumb + '%';
      var pct = max > 0 ? (cards.scrollLeft / max) : 0;
      var travel = 100 - thumb;
      fill.style.transform = 'translateX(' + (pct * travel) + '%)';
    }

    panels.forEach(function (panel) {
      var cards = panel.querySelector('[data-wsd-cards]');
      if (cards) cards.addEventListener('scroll', function () {
        if (panel.classList.contains('is-active')) updateCardProgress();
      }, { passive: true });
    });

    window.addEventListener('resize', updateCardProgress);
    activate(0);
  }

  function boot() {
    document.querySelectorAll('[data-wsd]').forEach(initWSD);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-wsd]');
    if (s) initWSD(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-selling-collection-redesign"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWSD(root) {
    if (root.dataset.wsdInit) return;
    root.dataset.wsdInit = '1';

    var tabs      = Array.prototype.slice.call(root.querySelectorAll('[data-wsd-tab]'));
    var panels    = Array.prototype.slice.call(root.querySelectorAll('[data-wsd-panel]'));
    var tabfill   = root.querySelector('[data-wsd-tabfill]');
    var tablist   = root.querySelector('[data-wsd-tablist]');
    var prevBtn   = root.querySelector('[data-wsd-prev]');
    var nextBtn   = root.querySelector('[data-wsd-next]');
    var viewall   = root.querySelector('[data-wsd-viewall]');
    var viewallTx = root.querySelector('[data-wsd-viewall-text]');
    var count     = tabs.length;
    var active    = 0;

    var viewData = [];
    var jsonEl = root.querySelector('[data-wsd-viewall-json]');
    if (jsonEl) { try { viewData = JSON.parse(jsonEl.textContent); } catch (e) {} }

    function activate(i) {
      i = Math.max(0, Math.min(count - 1, i));
      active = i;

      tabs.forEach(function (t, idx) {
        var on = idx === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p, idx) {
        var on = idx === i;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });

      if (tabfill) {
        var w = 100 / count;
        tabfill.style.width = w + '%';
        tabfill.style.transform = 'translateX(' + (i * 100) + '%)';
      }

      // keep active tab in view (mobile)
      if (tabs[i] && tablist) {
        var t = tabs[i];
        var left = t.offsetLeft - (tablist.clientWidth - t.clientWidth) / 2;
        tablist.scrollTo({ left: left, behavior: 'smooth' });
      }

      // bottom CTA
      if (viewData[i] && viewall) {
        if (viewallTx) viewallTx.textContent = viewData[i].t || '';
        viewall.setAttribute('href', viewData[i].h || '#');
      }

      updateCardProgress();
    }

    tabs.forEach(function (t, idx) {
      t.addEventListener('click', function () { activate(idx); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { activate(active - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { activate(active + 1); });

    // card carousel progress
    function updateCardProgress() {
      var panel = panels[active];
      if (!panel) return;
      var cards = panel.querySelector('[data-wsd-cards]');
      var fill  = panel.querySelector('[data-wsd-cardfill]');
      if (!cards || !fill) return;
      var max = cards.scrollWidth - cards.clientWidth;
      var thumb = Math.max(15, (cards.clientWidth / cards.scrollWidth) * 100);
      fill.style.width = thumb + '%';
      var pct = max > 0 ? (cards.scrollLeft / max) : 0;
      var travel = 100 - thumb;
      fill.style.transform = 'translateX(' + (pct * travel) + '%)';
    }

    panels.forEach(function (panel) {
      var cards = panel.querySelector('[data-wsd-cards]');
      if (cards) cards.addEventListener('scroll', function () {
        if (panel.classList.contains('is-active')) updateCardProgress();
      }, { passive: true });
    });

    window.addEventListener('resize', updateCardProgress);
    activate(0);
  }

  function boot() {
    document.querySelectorAll('[data-wsd]').forEach(initWSD);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-wsd]');
    if (s) initWSD(s);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
